import Image from 'next/legacy/image';

import { H3, H5 } from '@common/headline';

import healthCoachChatPreview from '@public/img/how-it-works/health-coach-chat-preview.png';

export const YourOwnNutritionist = (): JSX.Element => (
  <div className="flex flex-col lg:flex-row-reverse lg:items-center">
    <div className="lg:w-[50%] lg:pl-[5%]">
      <div className="mx-3 lg:max-w-[450px]">
        <H3>Your own registered nutritionist and community</H3>
      </div>
      <div className="mx-3 mt-4 lg:max-w-[450px]">
        <H5>
          Connect with others to learn and discuss specific aspects of the
          programme, such as exercise, weight-loss plateaus, and more!
        </H5>
      </div>
    </div>
    <div className="mt-10 lg:mt-0 lg:w-[50%]">
      <Image
        src={healthCoachChatPreview}
        width={1053}
        height={1104}
        alt="Health coach chat app preview"
      />
    </div>
  </div>
);
